import { render } from "./userManagement.vue?vue&type=template&id=4014ce08&ts=true"
import script from "./userManagement.vue?vue&type=script&lang=ts"
export * from "./userManagement.vue?vue&type=script&lang=ts"

import "./userManagement.vue?vue&type=style&index=0&id=4014ce08&lang=scss"

import exportComponent from "/codebuild/output/src2155066187/src/reference-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__